import { useTranslation, Trans } from "react-i18next";

import i1 from '../../img/i1.svg';
import i2 from '../../img/i2.svg';
import i3 from '../../img/i3.svg';
import i4 from '../../img/i4.svg';

function Common () {

    const { t } = useTranslation();
      
    return(
        <>
            <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px]">
                <p className="host-grotesk leading-[1.2] xl:text-[40px] text-[#382F12] text-[28px]">{t('home.15')}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 mt-[20px] xl:mt-[40px] gap-[10px] xl:gap-[20px]">
                    <div className="bg-[#EAE6DA] p-[20px] xl:p-[30px] xl:h-[240px] rounded-[10px]">
                        <img src={i1} alt="" />
                        <p className="host-grotesk text-[16px] xl:text-[19px] text-[#382F12] mt-[30px] xl:mt-[80px] leading-[1.2]">{t('home.16')}</p>
                        <p className="mt-[5px] text-[#000000B2] PtRoot text-[12px] xl:text-[14px] xl:max-w-[238px]">{t('home.17')}</p>
                    </div>
                    <div className="bg-[#EAE6DA] p-[20px] xl:p-[30px] xl:h-[240px] rounded-[10px]">
                        <img src={i2} alt="" />
                        <p className="host-grotesk text-[16px] xl:text-[19px] text-[#382F12] mt-[30px] xl:mt-[80px] leading-[1.2]">{t('home.18')}</p>
                        <p className="mt-[5px] text-[#000000B2] PtRoot text-[12px] xl:text-[14px] xl:max-w-[238px]">{t('home.19')}</p>
                    </div>
                    <div className="bg-[#EAE6DA] p-[20px] xl:p-[30px] xl:h-[240px] rounded-[10px]">
                        <img src={i3} alt="" />
                        <p className="host-grotesk text-[16px] xl:text-[19px] text-[#382F12] mt-[30px] xl:mt-[80px] leading-[1.2]">{t('home.20')}</p>
                        <p className="mt-[5px] text-[#000000B2] PtRoot text-[12px] xl:text-[14px] xl:max-w-[238px]">{t('home.21')}</p>
                    </div>
                    <div className="bg-[#EAE6DA] p-[20px] xl:p-[30px] xl:h-[240px] rounded-[10px]">
                        <img src={i4} alt="" />
                        <p className="host-grotesk text-[16px] xl:text-[19px] text-[#382F12] mt-[30px] xl:mt-[80px] leading-[1.2]">{t('home.22')}</p>
                        <p className="mt-[5px] text-[#000000B2] PtRoot text-[12px] xl:text-[14px] xl:max-w-[238px]">{t('home.23')}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Common;